import { ReponseChampModel } from 'src/graphql/generated-types';
import { FieldValueTypes } from 'src/app/_shared/classes/field-value';
import { arrayEmpty, arrayNotEmpty } from 'src/app/utils/array.utils';
import { getXmlBoolean, getXmlLine } from 'src/app/utils/soap.utils';
import {
    ActivityFormSectionModel
} from 'src/app/board/activity/activity-shared/components/activity-form-response/activity-form-responses.component';

function getStringForForm(response: ({ responseInformations: ReponseChampModel } & { value: any }), params: { namespace: string } = {namespace: 'd9p1'}): string {
    params = params || {namespace: 'd9p1'};
    if (response.responseInformations.CodeTypeChamp === FieldValueTypes.ListMultiple) {
        if (arrayEmpty(response.value)) {
            return '';
        }
        return !Array.isArray(response.value)
            ? getXmlLine({string: response.value}, 'string', params)
            : response.value?.map((value) => getXmlLine({string: value}, 'string', params))?.join('\n');
    } else if (response.responseInformations.CodeTypeChamp === FieldValueTypes.Boolean) {
        return getXmlBoolean({string: response.value}, 'string', params);
    } else {
        return getXmlLine({string: response.value}, 'string', params);
    }
}

export function activityFormResponsesXml(formResult: ActivityFormSectionModel): string {
    return `
        <d4p1:Formulaire
            xmlns:d5p2="http://schemas.datacontract.org/2004/07/V2DTO"
            i:type="d5p2:SoumissionFormulaireModel">
            ${getFormsList(formResult, {namespace: 'd5p2'})}
        </d4p1:Formulaire>
    `;
}

export function activityFormResponsesByOrderIdXml(orderId: number, formResult: ActivityFormSectionModel): string {
    return `
        <modeleSaveReponses
            xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
            xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/"
            xmlns:d5p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
            <d4p1:IdCommande>${orderId}</d4p1:IdCommande>
            <d4p1:ListeSoumissionFormulaire>
                <d4p1:SoumissionFormulaireModel>
                    ${getFormsList(formResult, {namespace: 'd4p1'})}
                </d4p1:SoumissionFormulaireModel>
            </d4p1:ListeSoumissionFormulaire>
        </modeleSaveReponses>
    `;
}

export function activityFormResponsesByOrderLineIdXml(orderLineId: number, formResult: ActivityFormSectionModel): string {
    return `
        <modeleSaveReponses
            xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
            xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/"
            xmlns:d5p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
            <d4p1:IdLigneCommande>${orderLineId}</d4p1:IdLigneCommande>
            <d4p1:ListeSoumissionFormulaire>
                <d4p1:SoumissionFormulaireModel>
                    ${getFormsList(formResult, {namespace: 'd4p1'})}
                </d4p1:SoumissionFormulaireModel>
            </d4p1:ListeSoumissionFormulaire>
        </modeleSaveReponses>
    `;
}

export function getFormsList(formResult: ActivityFormSectionModel, params: { namespace: string, reponseNamespace?: string } = {
    namespace: 'd4p1',
    reponseNamespace: 'd9p1'
}): string {

    if (!params.reponseNamespace) {
        params.reponseNamespace = 'd9p1';
    }

    const {sectionsList, formId} = formResult;
    const responsesList = sectionsList.flatMap(e => e.responsesList);

    return `
        ${getXmlLine(formId, 'IdFormulaire', {defaultValue: formId, namespace: params.namespace})}
        ${arrayNotEmpty(responsesList) ? `
        <${params.namespace}:ListeReponseObservable>
        ${responsesList.filter(response => !!response.responseInformations.IdChamp).map((response, index) => `
            <${params.namespace}:ValeurReponseModel z:Id="i${index + 1}">
                <${params.namespace}:IdChampData>${response.responseInformations.IdDataFormulaire}</${params.namespace}:IdChampData>
                <${params.namespace}:Reponse xmlns:${params.reponseNamespace}="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
                    ${getStringForForm(response, {namespace: params.reponseNamespace})}
                </${params.namespace}:Reponse>
            </${params.namespace}:ValeurReponseModel>
        `).join(' ')}
        </${params.namespace}:ListeReponseObservable>

        <${params.namespace}:ListeReponses xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
        ${responsesList.filter(response => !!response.responseInformations.IdChamp).map((response, index) => `
            <d6p1:anyType z:Ref="i${index + 1}">
            </d6p1:anyType>
        `).join(' ')}
        </${params.namespace}:ListeReponses>
        ` : `
        <${params.namespace}:ListeReponseObservable>
        </${params.namespace}:ListeReponseObservable>
        <${params.namespace}:ListeReponses xmlns:d6p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">
        </${params.namespace}:ListeReponses>` }
    `;
}
